import get from 'lodash/get';
export default function cancelSearchAlertsActionCreator(userDuck, personalization) {
  return id => async (dispatch, getState) => {
    // get current saved search object
    try {
      const cancelAlertsEvent = await personalization.cancelSearchAlerts(id);
      if (cancelAlertsEvent.userId) {
        dispatch(userDuck.creators.setGlobalAlert({
          key: 'cancelAlertsSuccess'
        }));
        const {
          user
        } = getState();
        const bookmarks = get(user, 'bookmarks.searchBookmarks', {});
        const bookmarkIds = Object.keys(bookmarks);
        const updatedBookmarks = {
          ...bookmarks
        };
        // iterate over bookmarks and set all alerts to false
        bookmarkIds.forEach(inventoryId => {
          updatedBookmarks[inventoryId] = {
            ...bookmarks[inventoryId],
            alert: {
              ...bookmarks[inventoryId].alert,
              sendEmailAlerts: false,
              sendTextAlerts: false
            }
          };
        });
        dispatch(userDuck.creators.setSearchBookmarks(updatedBookmarks));
      } else {
        // show server error message
        dispatch(userDuck.creators.setGlobalAlert({
          key: 'serverFailure',
          message: cancelAlertsEvent.message
        }));
      }
    } catch (error) {
      dispatch(userDuck.creators.setGlobalAlert({
        key: 'serverFailure',
        message: error
      }));
      throw Error(error);
    }
  };
}